<template>
  <component :is="modules.TermsConditions" v-if="termsConditions" v-bind="termsConditions" />
</template>

<script>
import moduleLoader from '~/utils/module-loader';
import { terms_conditions as TermsConditions } from '~/.modules.json';

// Set modules on page

const modules = [TermsConditions];

export default {
  props: {
    termsConditions: { type: Object, required: true },

    title: { type: String, required: false, default: null },
    metaTitle: { type: String, required: false, default: null },
    metaDescription: { type: String, required: false, default: null },
  },
  beforeCreate() {
    this.modules = moduleLoader(modules);
  },
  mounted() {
    this.$scrollEntrance.mount();
  },
  beforeDestroy() {
    this.$scrollEntrance.destroy();
  },
};
</script>
